import type { ReviewEntryTableRow } from '../types/reviewEntryTableRow'

const sortUniqueValues = (values: Iterable<string>): string[] =>
  [...new Set(values)].sort((left, right) => left.localeCompare(right))

export const getSupplierOptionsFromRows = (rows: ReviewEntryTableRow[]): string[] => {
  const suppliers = rows
    .filter((row) => row.showDocumentLevelFields && row.supplierName)
    .map((row) => row.supplierName as string)

  return sortUniqueValues(suppliers)
}

export const getAccountOptionsFromRows = (rows: ReviewEntryTableRow[]): string[] => {
  const accounts = rows.filter((row) => row.account).map((row) => row.account as string)

  return sortUniqueValues(accounts)
}
